import { useContext, useEffect } from "react";

import { UserContext } from "../contexts/User.jsx";
import { setDevtoolsGuardExempt } from "../core/devtoolsGuard.js";

// Keeps the DevTools guard's master-admin exemption in step with sign-in,
// sign-out and account switches. Renders nothing.
export default function DevtoolsGuard() {
  const isMasterAdmin = !!useContext(UserContext)?.user?.is_master_admin;

  useEffect(() => {
    setDevtoolsGuardExempt(isMasterAdmin);
  }, [isMasterAdmin]);

  return null;
}
